import React, { useState, useContext } from "react";
import './ProductCard.css';
import { OrderContext } from "../../contexts/OrderContext";
import { MEDIA_URL } from "../../utils/constants";

function ProductCard({ props }) {
  const [quantity, setQuantity] = useState(0);
  const { addItem } = useContext(OrderContext);

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  return (
    <li className="product-card-item">
      <div className="product-card-div">
        <div className="product-image">
          <img src={MEDIA_URL + props.image} alt={props.name} loading="lazy" />
        </div>
        <div className="product-info">
          <h3>{props.name}</h3>
          <p>{props.description}</p>
          {props.stock > 0 ? (
            <div className="product-ordering">
              <input
                type="number"
                min="0"
                step="1"
                defaultValue="0"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d+$/.test(value) || value === "") {
                    handleQuantityChange(e);
                  } else {
                    e.target.value = value.replace(/[^0-9]/g, "");
                  }
                }}
              />
              <button
                className="common-button"
                onClick={() => addItem(props, quantity)}
              >
                <span className="material-symbols-outlined">add_shopping_cart</span>
              </button>
            </div>
          ) : (
            <div className="product-not-aviable">
              <h3>Sin stock</h3>
            </div>
          )}
        </div>
      </div>
    </li>
  );

}

export default ProductCard;